import { render, staticRenderFns } from "./WapJSY002Detail.vue?vue&type=template&id=1ed55618&"
import script from "./WapJSY002Detail.vue?vue&type=script&lang=js&"
export * from "./WapJSY002Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports